import { Primary12SemiBold, SimpleModal } from '@sequencehq/core-components'
import { useCreditNoteActions } from 'CreditNotes/hooks/useCreditNoteActions'

type Props = {
  creditNoteId: string
  isOpen: boolean
  onClose: () => void
}

export const MarkAsSentCreditNoteDialog = ({
  creditNoteId,
  isOpen,
  onClose
}: Props) => {
  const { markAsSent } = useCreditNoteActions(creditNoteId)

  const handleSubmit = async () => {
    try {
      await markAsSent.mutateAsync()
    } catch {
      // The mutation's onError toast covers messaging; keep the dialog open
      // so the action can be retried in place.
      return false
    }

    return true
  }

  return (
    <SimpleModal
      data-testid="modal.markAsSentCreditNote"
      variant="dialog"
      isOpen={isOpen}
      onClose={onClose}
      title="Mark credit note as sent"
      submitButtonText="Mark credit note as sent"
      submittingButtonText="Marking as sent..."
      onSubmit={handleSubmit}
      disableSubmitOnEnter
    >
      This marks the credit note as{' '}
      <span style={{ fontWeight: Primary12SemiBold.fontWeight }}>Sent</span>. No
      email will be sent and the credit note will not automatically sync to
      connected integrations. You will no longer be able to edit this credit
      note. This action cannot be undone.
    </SimpleModal>
  )
}
